<form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="form-group">
    <label class="form-label required">Full name </label>
    <input [(ngModel)]="model.fullName" formControlName="fullName" type="text" class="form-control">
    <input-errors [control]="form.controls.fullName" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label required">Username </label>
    <input [(ngModel)]="model.username" formControlName="username" type="text" class="form-control">
    <input-errors [control]="form.controls.username" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label required">Email </label>
    <input [(ngModel)]="model.email" formControlName="email" type="text" class="form-control" required disabled>
    <input-errors [control]="form.controls.email" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label required">Phone </label>
    <input [(ngModel)]="model.phone" formControlName="phone" type="text" class="form-control">
    <input-errors [control]="form.controls.phone" [service]="validationService"></input-errors>
  </div>
  <div class="hr-line-dashed"></div>
  <div class="form-group position-relative">
    <label class="form-label required">New password </label>
    <input [(ngModel)]="model.password" formControlName="password" [attr.type]="newPasswordType" class="form-control">
    <span class="icon position-absolute" (click)="togglePasswordType('newPassword')"
      [ngClass]="form.controls.password.pending ? 'icon-wait spin' :{ 'icon-show': !isPasswordType('newPassword'), 'icon-hide': isPasswordType('newPassword') }"></span>
    <input-errors [control]="form.controls.password" [service]="validationService"></input-errors>
  </div>
  <div class="form-group position-relative">
    <label class="form-label required">Repeat new password </label>
    <input [(ngModel)]="repeatPassword" formControlName="repeatPassword" [attr.type]="newPasswordType" class="form-control">
    <span class="icon position-absolute" (click)="togglePasswordType('newPassword')"
      [ngClass]="{ 'icon-show': !isPasswordType('newPassword'), 'icon-hide': isPasswordType('newPassword') }"></span>
    <input-errors [control]="form.controls.repeatPassword" [service]="validationService"></input-errors>
  </div>
  <div class="hr-line-dashed"></div>
  <div class="d-flex justify-content-end">
    <button type="submit" [disabled]="!form.valid" class="btn btn-primary"> Apply </button>
  </div>
</form>
